import React from "react";
import UIfx from "uifx";
import beepErrorMp3 from "../../../../../sounds/beep-error.mp3";
import beepSuccessMp3 from "../../../../../sounds/beep-success.mp3";
import Select from "../../../../form/Select";
import {BarcodeFormatter, ProductSelect} from "../../../../../utils/formatters";
import TextInput from "../../../../form/TextInput";
import {ifCompletedInput} from "../../../../../utils/other";

const beepError = new UIfx(beepErrorMp3, {});
const beepSuccess = new UIfx(beepSuccessMp3, {});

export default class ProductPicker extends React.Component {

    state = {
        picked: null
    }

    called = false;

    addPickedItem = async () => {
        if (this.props.async !== true) {
            if (this.called) return;
        }
        this.called = true;
        if (this.state.picked.picked > 1000) {
            beepError.play();
            return;
        }
        try {
            if (this.props.async !== true) {
                this.props.addPickedItem && await this.props.addPickedItem(this.state.picked);
            } else {
                this.props.addPickedItem && this.props.addPickedItem(this.state.picked);
            }
            this.setState({
                picked: null,
            }, () => {
                // szomorú timeout
                setTimeout(() => {
                    this.productPicker.focus();
                }, 50);
                beepSuccess.play();
            });
        } catch (e) {
            console.error(e);
            beepError.play();
        }
        this.called = false;
    }

    render() {
        return (
            <div className="row form-row">
                <div className="col-md-9">
                    <Select
                        ref={(input) => this.productPicker = input}
                        label="Termék"
                        component="product"
                        labelKey="displayname"
                        storeType="remote"
                        valueKey="id"
                        view={["product_id", "qty", "vat", "listprice", "displayname", "sku", "barcode"]}
                        optionsTemplate={ProductSelect}
                        autoSelect={true}
                        searchFormatter={BarcodeFormatter}
                        placeholder="Vonalkód vagy cím"
                        objectValue={true}
                        openIfHasOptions={true}
                        value={this.state.picked}
                        saveChanges={(field, value) => {
                            value.picked = 1;
                            this.setState({picked: value}, () => {
                                this.numberInput.focus();
                                this.numberInput.select();
                            });
                        }}
                    />
                </div>
                <div className="col-md-3">
                    <TextInput
                        disabled={!this.state.picked}
                        type="number"
                        ref={(input) => this.numberInput = input}
                        name="picked"
                        value={(this.state.picked || {}).picked}
                        label="Darabszám (Összesen)"
                        onKeyDown={(e, field, value) => {
                            if (ifCompletedInput(e)) {
                                this.setState({
                                    picked: {
                                        ...this.state.picked,
                                        qty: value
                                    }
                                }, async () => {
                                    await this.addPickedItem();
                                });
                            } else if(e.which === 27) {
                                this.setState({
                                    picked: null,
                                }, () => {
                                    this.productPicker.focus();
                                });
                            }
                        }}
                        {...this.props.props.getFieldProps("picked")}
                        saveChanges={(field, value) => {
                            if (this.state.picked) {
                                this.setState({
                                    picked: {
                                        ...this.state.picked,
                                        qty: value
                                    }
                                });
                            }
                        }}
                    />
                </div>
                {this.state.picked && <div className="col-md-12">
                    <ProductSelect {...this.state.picked}/>
                </div>}
            </div>
        );
    }
}